import { storage } from "./config";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  listAll,
  deleteObject,
} from "firebase/storage";

// 🔼 Upload a document
export async function uploadEmployeeDocument(companyId, employeeId, file) {
  const fileRef = ref(
    storage,
    `companies/${companyId}/employees/${employeeId}/documents/${file.name}`
  );
  await uploadBytes(fileRef, file);
  return getDownloadURL(fileRef);
}

// 📄 List all uploaded documents
export async function listEmployeeDocuments(companyId, employeeId) {
  const folderRef = ref(
    storage,
    `companies/${companyId}/employees/${employeeId}/documents`
  );
  const result = await listAll(folderRef);

  const files = await Promise.all(
    result.items.map(async (item) => {
      const url = await getDownloadURL(item);
      return {
        name: item.name,
        url,
        fullPath: item.fullPath,
      };
    })
  );

  return files;
}

// ❌ Delete a document
export async function deleteEmployeeDocument(fullPath) {
  const fileRef = ref(storage, fullPath);
  await deleteObject(fileRef);
}
